import { logAndReject } from '../../utils/promise'
import Airport from '../models/airport'
import { getThemeAPIName, Theme } from '../models/funnelOrder/theme'
import { getSiteCountryICC2, SiteCountry } from '../models/locale'
import { getClient } from '../openapi'

export function getAirports(
  country: SiteCountry,
  theme?: Theme,
): Promise<Airport[]> {
  return getClient()
    .then(client =>
      client.apis.bookings.bookings_airports_list({
        site_country: getSiteCountryICC2(country),
        theme: theme ? getThemeAPIName(theme) : undefined,
      }),
    )
    .then(response => response.body.map((a: any) => mapAPIToAirport(a)))
    .catch(logAndReject)
}

export function mapAPIToAirport(data: any): Airport {
  return {
    id: data.id,
    name: data.name,
    nameWithAirport: data.name_with_airports,
    code: data.id.toString(),
    stopover: data.stopover,
    stopoverOutsideEU: data.stopover_outside_eu,
    hideOutsideEU: data.hide_outside_eu,
  }
}
